import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * `cn` — the canonical shadcn/ui class-name composer.
 *
 * Combines `clsx` (conditional class handling, array / object
 * syntaxes) with `tailwind-merge` (deduplicates conflicting
 * Tailwind utilities so e.g. `cn('p-4', condition && 'p-6')`
 * yields just `p-6` when the condition holds).
 *
 * Used everywhere a component composes Tailwind classes from a
 * fixed base + variant + caller-supplied `className` prop.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
